<template>
  <div>
    <template v-if="renderedFrom === 'admin'">
      <button class="button is-primary is-small" :class="{ 'is-loading': isSending }" @click="getInvoices">
        <span>Refresh</span>
      </button>
    </template>
    <template v-if="invoices.length">
      <table class="table">
        <thead>
          <tr>
            <th>Date</th>
            <th>Action</th>
            <th>Description</th>
            <th style="text-align: right !important;">Amount</th>
            <th>Currency</th>
            <th>Receipt</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="invoice in invoices">
            <td>{{ invoice.createdAt | dateFormatNoTime }}</td>
            <td>{{ invoice.action }}</td>
            <td>{{ invoice.description }}</td>
            <td class="has-text-right">{{ (invoice.amount / 100) | formatAsCurrency }}</td>
            <td class="has-text-centered" style="text-transform: uppercase">{{ invoice.currency }}</td>
            <td><a target="_blank" :href="invoice.receiptUrl">Open receipt</a></td>
          </tr>
        </tbody>
      </table>
    </template>
  </div>
</template>

<script>
// import Message from 'vue-bulma-message'
import { buildEndpoint } from '../../../libs/buildEndPoint';

export default {
  components: {
    // Message
  },

  props: {
    organisation: Object,
    renderedFrom: String,
  },

  data() {
    return {
      invoices: [],
      error: null,
      isSending: false,
    };
  },

  watch: {},

  created() {},

  mounted() {
    this.getInvoices();
  },

  methods: {
    getInvoices() {
      const _this = this;
      const endpoint = this.renderedFrom === 'admin'
        ? `admin/organisations/billing/invoices/${this.organisation._id}`
        : 'organisation-admin/organisation/billing/customer/invoices';
      _this.isSending = true;
      _this.$http
        .get(buildEndpoint(endpoint))
        .then((response) => {
          _this.isSending = false;
          if (response.data.success) {
            _this.invoices = response.data.data.invoices;
          } else {
            _this.error = `Error getting invoices: ${response.data.error}`;
          }
        })
        .catch((error) => {
          _this.isSending = false;
          _this.error = error;
        });
    },
  },
};
</script>

<style lang="scss" scoped=""></style>
